import React, { Component }        from 'react'
import { connect }                 from 'react-redux'
import { AllocationActions }       from 'actionsets'
import { SnackbarActions }         from 'actionsets'
import { TransactionActions }      from 'actionsets'
import Dependent, { GlobalLoader } from 'containers/shared/Dependent'
import { withRouter }              from 'react-router'
import AllocationView              from 'components/allocation'
import { timeout } from 'utils'
import moment from 'moment'
import 'utils/locale'
import CenteredContent from 'containers/CenteredContent'
import { TransactionDialog } from 'containers/transactions'

const ALLOCATION_REFRESH_INTERVAL = parseInt(process.env.REACT_APP_ALLOCATION_REFRESH_INTERVAL, 10) || 30000

export class Allocation extends Component{

  constructor(props){
    super(props)
    AllocationActions.bindActions(this)
    SnackbarActions.bindActions(this, 'snackbar')
    TransactionActions.bindActions(this, 'transaction')
    this.state = {
      ...this.state,
      expandedAllocations: []
    }
  }

  componentDidMount = () => {
    this._isMounted = true
    if (this.allocations) {
      this.expandDefaultAllocations(this.props)
    }
    this.pollAllocations()
  }

  componentWillUnmount = () => {
    this._isMounted = false
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.allocationId !== this.getAllocationId(prevProps)) {
      this.expandDefaultAllocations(this.props)
    }
  }

  hasAllocationClosed = (allocation) => {
    return moment(allocation.endDate) <= moment(Date.now())
  }

  expandDefaultAllocations = (props) => {
    this.setState({
      expandedAllocations: props.allocations.filter(a => (!this.hasAllocationClosed(a) && !this.getAllocationId(props)) || a.id.toString() === this.getAllocationId(props)).map(a => a.id)
    })
  }

  pollAllocations = async () => {
    if(this._isMounted) {
      await this.loadAllocation()
      await timeout(ALLOCATION_REFRESH_INTERVAL)
      this.pollAllocations()
    }
  }

  async loadAllocation(){
    await this.actions.index({dealSheetId: this.dealSheetId, size: 1000})
  }

  dependsOn(){
    const allocationLoad = this.loadAllocation()
    if(!this.allocations.length){
      return allocationLoad
    }
  }

  dependenciesMet(){
    return !this.pendingTncsRequest && (this.allocations.length || !this.pendingDataRequest)
  }

  get pendingDataRequest() {
    return !!this.props.requests.find(r => r.type === AllocationActions.INDEX)
  }

  get pendingTncsRequest() {
    return !!this.props.requests.find(r => r.type === AllocationActions.LOAD_TERMS_AND_CONDITIONS)
  }

  get allocationId() {
    return this.getAllocationId(this.props)
  }

  getAllocationId = (props) => {
    return props.match.params.allocationId
  }

  get allocations() {
    if (this.props.allocations && this.props.allocations.find(a => a.dealSheetId.toString() === this.dealSheetId)) {
      return this.props.allocations
    } else {
      return []
    }
  }

  get dealSheetId() {
    return this.props.match.params.id
  }

  handleInvestTncsAgreed = async (allocation, tokenDestinationAddress) => {
    try {
      await this.actions.invest({id: allocation.id, tncsAgreed: true, tokenDestinationAddress})
      this.actions.snackbar.success('A deposit address has been created for you.')
    }
    catch(ex) {
      this.actions.snackbar.error('Could not create a deposit address.')
    }
  }

  handleRequestTncs = async(allocation) => {
    try {
      await this.actions.loadTermsAndConditions({id: allocation.id})
    } catch(err){
      this.actions.snackbar.error('Failed while loading Terms and Conditions.')
      console.error(err)
    }
  }

  handleRefund = transaction => {
    this.createTransactionEvent(transaction, 'refund', 'Transaction has been marked as refunded')
  }

  handleCreateTransaction = (allocation) => {
    this.setState({transactionAllocation: allocation})
  }

  handleDeleteTransaction = async (transaction) => {
    try {
      await this.actions.transaction.destroy(transaction)
      this.actions.snackbar.success('Transaction Deleted')
      this.loadAllocation()
    }
    catch(ex) {
      this.actions.snackbar.error('Could not delete transaction')
    }
  }

  handleTransactionDialogClose = async (saved) => {
    if (saved) {
      this.loadAllocation()
    }
    this.setState({transactionAllocation: undefined})
  }

  createTransactionEvent = async(transaction, event, message) => {
    try {
      await this.actions.transaction.createEvent(transaction.id, {name: event})
      this.actions.snackbar.success(message)
    }
    catch(ex) {
      this.actions.snackbar.error('Could not send request')
    }
  }

  allocationExpanded(allocation) {
    return !!this.state.expandedAllocations.find(a => a === allocation.id)
  }

  handleExpandAllocation(allocation) {
    if (this.allocationExpanded(allocation))
      this.setState({expandedAllocations: this.state.expandedAllocations.filter(a => a !== allocation.id)})
    else
      this.setState({expandedAllocations: [...this.state.expandedAllocations, allocation.id]})
  }

  render = () =>
    <CenteredContent>
      {this.allocations && this.allocations.map(allocation =>
        <AllocationView key={allocation.id}
                        allocation={allocation}
                        expanded={this.allocationExpanded(allocation)}
                        onExpand={() => this.handleExpandAllocation(allocation)}
                        tncs={this.props.termsAndConditions}
                        onRequestTncs={this.handleRequestTncs}
                        onInvestTncsAgreed={this.handleInvestTncsAgreed}
                        onRefund={this.handleRefund}
                        onCreateTransaction={this.handleCreateTransaction}
                        onDeleteTransaction={this.handleDeleteTransaction}/>
      )}
      <TransactionDialog
        allocation={this.state.transactionAllocation}
        onClose={this.handleTransactionDialogClose}
      />
    </CenteredContent>
}

export default connect(({allocations, dealSheets: { dealSheet }}) => ({...allocations, dealSheet}))(withRouter(Dependent({loader: GlobalLoader})(Allocation)))